module.exports = __webpack_public_path__ + "img/Illustration.9986a2a3.png";